import React from "react";

const SIZES = { xs: 12, sm: 16, md: 26, lg: 40 };

/** The owl is watching while you wait — two lime eyes that blink and glance about. */
export const OwlLoader = ({ size = "md", label, className = "", testId = "owl-loader" }) => {
  const s = SIZES[size] || SIZES.md;
  const gap = Math.max(3, Math.round(s * 0.22));
  return (
    <span className={`inline-flex items-center ${label ? "gap-2.5" : ""} ${className}`}
      role="status" aria-label={label || "Loading"} data-testid={testId}>
      <span className="owl-eyes inline-flex items-end" style={{ gap }}>
        {[0, 1].map((i) => (
          <span key={i} className="owl-eye" style={{ width: s, height: s }}>
            <span className="owl-pupil" style={{ width: s * 0.42, height: s * 0.42 }} />
          </span>
        ))}
      </span>
      {label && <span className="text-sm text-muted-foreground">{label}</span>}
    </span>
  );
};

/** Centred block version for page and panel loading states. */
export const OwlLoaderBlock = ({ label, size = "lg", className = "" }) => (
  <div className={`flex flex-col items-center justify-center gap-3 py-10 ${className}`}
    data-testid="owl-loader-block">
  <OwlLoader size={size} testId="owl-loader-block-eyes" />
    {label && <div className="text-sm text-muted-foreground">{label}</div>}
  </div>
);
